export const buttons = {
  edit: "Edytować",
  delete: "Usunąć",
  update: "",
  create: "Dodaj nowy element",
  save: "Zapisz",
  select: "Wybierz obraz",
};
